import { TomlValues } from "../../types/sep";

export const fetchTomlValues = async (TOML_FILE_URL: string): Promise<TomlValues> => {
  const response = await fetch(TOML_FILE_URL);
  if (response.status !== 200) {
    throw new Error(`Failed to fetch TOML file: ${response.statusText}`);
  }

  const tomlFileContent = (await response.text()).split("\n");
  const findValueInToml = (key: string): string | undefined => {
    const keyValue = tomlFileContent.find(line => line.includes(key));
    return keyValue?.split("=")[1].trim().replaceAll('"', "");
  };

  return {
    kycServer: findValueInToml("KYC_SERVER"),
    sep6Url: findValueInToml("TRANSFER_SERVER"),
    sep24Url: findValueInToml("TRANSFER_SERVER_SEP0024"),
    signingKey: findValueInToml("SIGNING_KEY"),
    webAuthEndpoint: findValueInToml("WEB_AUTH_ENDPOINT")
  };
};
